<template>
    <div>
        <v-form ref="form">
            <v-container>
                <v-layout wrap>
                    <v-flex md5 sm12>
                        <v-text-field
                                v-model="data.name"
                                append-icon="edit"
                                :label="$t('common.name')"
                                :rules="[rules.required]"
                                single-line
                                hide-details
                        ></v-text-field>
                    </v-flex>
                    <v-spacer></v-spacer>
                    <v-flex md1>
                        <v-btn color="primary" dark class="mb-2" @click='save' :loading="loading">{{ $t("common.save") }}</v-btn>
                    </v-flex>
                </v-layout>
            </v-container>
        </v-form>
        <div id='map'>
        </div>

    </div>
</template>
<script>
    import Mapbox from "mapbox-gl";
    import MapboxDraw from "@mapbox/mapbox-gl-draw";
    import centroid from "@turf/centroid";
    import '@mapbox/mapbox-gl-draw/dist/mapbox-gl-draw.css'

    export default {
        name: "ContainerEditor",
        title() { return this.$t("maps.containerEditor.title"); },
        data() {
            return {
                mode: "add", // or edit
                id: null,
                map: null,
                loading: false,
                drawComponent: null,
                answer: null,
                center: null,
                data: {
                    name: null,
                }
            }
        },
        mounted() {
            Mapbox.accessToken = this.api.mapBox.accessToken;
            this.center = this.api.mapBox.center;
            if (this.$route.params.id !== undefined) {
                this.mode = "edit";
                this.id = this.$route.params.id;
                this.getData();
            }
            else {
                this.mode = "add";
                this.loadMap();
            }
        },
        methods: {
            loadMap() {
                this.map = new Mapbox.Map(Object.assign({container: 'map',},
                    this.api.mapBox,
                    {center: this.center}
                ));
                this.drawComponent = new MapboxDraw({
                    displayControlsDefault: false,
                    controls: {
                        polygon: true,
                        trash: true
                    }
                });
                this.map.addControl(this.drawComponent);
                this.map.on('draw.create', this.updateArea);
                this.map.on('draw.delete', this.updateArea);
                this.map.on('draw.update', this.updateArea);
            },
            getData() {
                this.axios.get(this.api.ACTIONS.LOCATION_CONTAINERS + `/${this.id}`).then(
                    ({data}) => {
                        const {name, polygon} = data.data;
                        this.center = centroid(polygon).geometry.coordinates;
                        console.log(this.center);
                        this.loadMap();
                        this.drawComponent.add(polygon);
                        this.data.name = name;
                    }
                )
            },
            updateArea(e) {
                if (e.type === "draw.create") {
                    this.drawComponent.deleteAll();
                    this.drawComponent.add(e.features[0]);
                }
            },
            reset() {
                this.drawComponent.deleteAll();
                this.data.name = null;
                this.data.radius = null;
            },
            save() {
                const polygons = this.drawComponent.getAll().features;
                if (!this.loading && this.$refs.form.validate()) {
                    if (polygons.length === 0) {
                        alert(this.$t("maps.containerEditor.choosePolygon"));
                        return;
                    }
                    this.loading = true;
                    const polygon = polygons[0].geometry;
                    const url = this.mode === "add" ? this.api.ACTIONS.LOCATION_CONTAINERS : this.api.ACTIONS.LOCATION_CONTAINERS + "/" + this.id;
                    (this.mode === "add" ? this.axios.post : this.axios.put)(url, {polygon, ...this.data}).then(
                        () => {
                            window.getApp.$emit("SHOW_TOAST", this.$t("maps.containerEditor.saved"), "green");
                            this.mode === "add" ? this.reset() : null;
                        }
                    ).catch(
                        () => window.getApp.$emit("SHOW_TOAST", this.$t("maps.containerEditor.notSaved"), "red")
                    ).finally(
                        () => this.loading = false
                    )
                }
            }
        },
        computed: {
            rules() {
                return {
                    required: value => !!value || this.$t("maps.containerEditor.requiredRule"),
                    number: value => isFinite(value) || this.$t("maps.containerEditor.mustBeNumber")
                };
            }
        }
    }
</script>


<style scoped>

    #map {
        width: 100%;
        height: 720px;
    }
</style>